import { Box, Divider, Stack } from "@mui/material";
import dayjs from "dayjs";
import { Fragment } from "react";
import { dateTimeConversionService } from "../../../shared/services/DateTimeConversionService";
import { OrderModel } from "../types/OrderModel";
import { orderMappers } from "../mappers/OrderMappers";
import {
    portfolioCalculationService
} from "../../../shared/services/portfolio-calculation-service/PortfolioCalculationService";
import { assetService } from "../../../shared/services/AssetService";

export function OrderInfoTooltipTitle({
    orderModel
}: {
    orderModel: OrderModel
}) {
    function getExpirationDateInfoText(expirationDate: Date | null): string | null {
        if (expirationDate === null)
            return null;

        const expirationDateJs = dayjs(expirationDate);
        
        return expirationDateJs.diff(dateTimeConversionService.getCurrentUtcDate(), 'hours') < 48
            ? `${expirationDateJs.format("dddd DD.MMM.YYYY HH:mm:ss")} (${expirationDateJs.diff(dateTimeConversionService.getCurrentUtcDate(), 'hours')} h)`
            : `${expirationDateJs.format("dddd DD.MMM.YYYY HH:mm:ss")} (${expirationDateJs.diff(dateTimeConversionService.getCurrentUtcDate(), 'days')} d)`;
    }

    return (
        <Fragment>
            <Box sx={{fontSize: "13px", fontWeight: "600"}}>Order details</Box>
            <Divider sx={{ paddingTop: "5px", borderColor: '#f2f3f3' }}/>
            <Stack direction="row" sx={{fontSize: "13px", paddingTop: "5px"}}>
                <Box width="110px">Id</Box><div>{orderModel.externalId}</div>
            </Stack>
            <Stack direction="row" sx={{fontSize: "13px"}}>
                <Box width="110px">Asset type</Box><div>{orderMappers.getTypeStringValue(orderModel.type)}</div>
            </Stack>
            {
                assetService.isOption(orderModel) &&
                orderModel.strike &&
                <Stack direction="row" sx={{fontSize: "13px"}}>
                    <Box width="110px">Strike</Box><div>{orderModel.strike}</div>
                </Stack>
            }
            {
                assetService.isOption(orderModel) &&
                orderModel.expireAt &&
                <Stack direction="row" sx={{fontSize: "13px"}}>
                    <Box width="110px">Expiry date</Box><div>{getExpirationDateInfoText(orderModel.expireAt)}</div>
                </Stack>
            }
            {
                assetService.isOption(orderModel) &&
                orderModel.expirationPrice &&
                <Stack direction="row" sx={{fontSize: "13px"}}>
                    <Box width="110px">Expiry price</Box>{orderModel.expirationPrice.toFixed(2)}
                </Stack>
            }
            {
                assetService.isOption(orderModel) &&
                orderModel.expirationPrice &&
                <Stack direction="row" sx={{fontSize: "13px"}}>
                    <Box width="110px">Balance</Box>{
                        portfolioCalculationService.balance
                            .calculateOrderBalanceAfterExpiration(orderModel).toFixed(2)
                    }
                </Stack>
            }
            <Stack direction="row" sx={{fontSize: "13px"}}>
                <Box width="110px">Open date</Box><div>{dateTimeConversionService.convertDateToCustomFormattedString(orderModel.openedPositionAt, "dddd DD.MMM.YYYY HH:mm:ss")}</div>
            </Stack>
            {
                orderModel.underlyingPriceAtOpen &&
                <Stack direction="row" sx={{fontSize: "13px"}}>
                    <Box width="110px">Underlying price</Box><div>{orderModel.underlyingPriceAtOpen?.toFixed(2) ?? ' '}</div>
                </Stack>
            }
        </Fragment>
    )
}
